import EditTotalTransferModal from './EditTotalTransferModal.vue';

export default EditTotalTransferModal;
